import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Modal, Row } from "antd";
import { MailOutlined } from "@ant-design/icons";

import "../../assets/css/kanban-view.css";
import CopyText from "../web2lead/CopyText";
import amount from "../../assets/images/lead-management/amount.svg";
import company from "../../assets/images/lead-management/company.svg";
import designation from "../../assets/images/lead-management/designation.svg";
import noData from "../../assets/images/lead-management/no-data.svg";
import phone from "../../assets/images/lead-management/phone.svg";
import UpdateLeadDetails from "./UpdateLeadDetails";
import MarkAsLostModal from "./MarkAsLost";

const customStatus = [
  {
    key: 0,
    title: "Open",
    class: "open",
  },
  {
    key: 1,
    title: "Contacted",
    class: "contacted",
  },
  {
    key: 2,
    title: "Converted",
    class: "converted",
  },
  {
    key: 3,
    title: "Unqualified",
    class: "unqualified",
  },
];

const KanbanView = ({
  dragStartEvent,
  dropEvent,
  localExecutiveEmployeeList,
  draggableLead,
  updateLead,
}) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState();
  const [isConfirm, setConfirm] = useState(false);
  const [isDragged, setDragged] = useState(false);
  const kanbanView = localExecutiveEmployeeList?.map((d) => d?.executiveData);
  const handleCancel = () => {
    setConfirm(false);
    setStatus();
    setDragged(false);
  };

  return (
    <div className="kanban-view">
      <Row className="kanban-container position-relative">
        {kanbanView &&
          kanbanView
            ?.filter((d) =>
              [
                "New Lead",
                "Sales Qualified",
                "Opportunity ",
                "Un-Qualified",
              ].includes(d?.statusText)
            )
            .map((data, index) => {
              const customItem = customStatus[index];
              let totalAmount = data?.leadsList?.reduce(
                (sum, d) => sum + (parseInt(d?.oppurtunityAmount) || 0),
                0
              );
              return (
                <Col key={index} xs={6} style={{ padding: "0", minWidth: 250 }}>
                  <div className={`status-card ${customItem.class}`}>
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: 20 }}
                    >
                      <span className="heading13px">{customItem?.title}</span>
                      <span className="text-color-030334 heading12px fw-normal">
                        &#x20b9;{totalAmount}
                      </span>
                    </div>
                    <div className="count-badge white-space-nowrap">
                      {data?.totalRecords} Lead
                    </div>
                  </div>

                  <div
                    className="status-container"
                    onDragOver={(e) => {
                      e.preventDefault();
                    }}
                    onDragEnter={(e) => {
                      e.preventDefault(); // Prevent scrolling
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      dropEvent(data);
                      setDragged(false);
                    }}
                  >
                    {data?.leadsList?.length ? (
                      data?.leadsList?.map((lead, i) => (
                        <div
                          key={i}
                          id="cd3"
                          draggable="true"
                          onDragStart={(e) => {
                            setDragged(true);
                            dragStartEvent(e, lead, data);
                          }}
                          className={`lead-card draggable`}
                        >
                          <span className="heading13px fw-bold d-flex align-items-center justify-content-between">
                            <span
                              className="cursor-pointer"
                              onClick={() =>
                                navigate(`/lead-details/${lead?.id}`)
                              }
                            >
                              {lead?.fullname
                                ? lead?.fullname
                                : (lead?.firstname || "") +
                                  " " +
                                  (lead?.latname || "")}
                            </span>

                            <UpdateLeadDetails lead={lead} />
                          </span>
                          {lead?.title && (
                            <span className="heading12px">
                              <span
                                className="d-flex align-items-center"
                                style={{ gap: 5 }}
                              >
                                <img src={designation} alt="" />
                                {lead?.title}
                              </span>
                            </span>
                          )}
                          {lead?.companyName && (
                            <span className="heading12px">
                              <span
                                className="d-flex align-items-center"
                                style={{ gap: 5 }}
                              >
                                <img src={company} alt="" />
                                {lead?.companyName}
                              </span>
                            </span>
                          )}
                          <span className="heading12px d-flex align-items-center justify-content-between">
                            <span
                              className="d-flex align-items-center"
                              style={{ gap: 5 }}
                            >
                              <img src={amount} alt="" /> &#x20b9;
                              {lead?.oppurtunityAmount || 0}
                            </span>
                            <span
                              className="d-flex align-items-center heading14px"
                              style={{ gap: 5 }}
                            >
                              {lead?.phoneNo && (
                                <CopyText
                                  content={
                                    <img
                                      src={phone}
                                      alt=""
                                      className="cursor-pointer"
                                    />
                                  }
                                  text={lead?.phoneNo}
                                />
                              )}
                              {lead?.emailId && (
                                <CopyText
                                  content={<MailOutlined />}
                                  text={lead?.emailId}
                                />
                              )}
                            </span>
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="no-data">
                        <img src={noData} alt="" />
                      </div>
                    )}
                  </div>
                </Col>
              );
            })}
        {!!isDragged && (
          <Col
            xs={24}
            className="d-flex float-buttons align-items-center justify-content-between gap-20"
          >
            <div
              className={`float-lead-btn float-button-delete ${status === "delete" ? "drag-over-delete" : ""}`}
              onDragOver={(e) => {
                setStatus("delete");
                e.preventDefault();
              }}
              onDragEnter={(e) => {
                e.preventDefault(); // Prevent scrolling
              }}
              onDragLeave={() => setStatus()}
              onDrop={(e) => {
                e.preventDefault();
                setConfirm(true);
              }}
            >
              <div className="d-flex align-items-center gap-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25.156"
                  height="26.754"
                  viewBox="0 0 25.156 26.754"
                >
                  <g id="Folder_Download" transform="translate(-5.063 -3.098)">
                    <g
                      id="Group_210"
                      data-name="Group 210"
                      transform="translate(5.063 3.098)"
                    >
                      <path
                        d="M30.1,8.991c.027-.084.217-.3.063-.5a.305.305,0,0,0-.3-.114c-1.067.215-2.106.431-3.133.648l.568-2.293a.3.3,0,0,0-.412-.349c-.414.08-.831.162-1.248.243a10.191,10.191,0,0,0,.186-1.279.306.306,0,0,0-.355-.245l-.542.1c-.051-.489-.224-1.406-.544-1.574a1.4,1.4,0,0,0-.588-.029l-.861-.5q-4.469.767-8.871,1.868A7.927,7.927,0,0,1,13.682,4c-.228-.773-1.043-.836-1.836-.724-1.677.241-3.883.155-4.923.841a1.093,1.093,0,0,0-.249.23,5.649,5.649,0,0,0-.759.556c-1.239,1.032-.812.952-.637,17.55.007.641.863,1.048,1.528,1.044a.382.382,0,0,0,.26.037c4.47-1.2,9.022-2.353,13.869-3.64,0,.381,0,.749,0,1.1-.6.064-1.268.033-1.855.046-.281.2-.491.411-.745.616a.3.3,0,0,0-.215.519c1.669,1.685,3.084,3.558,4.828,5.107a.3.3,0,0,0,.427-.022c.731-.8,3.23-3.62,4.5-5.1a.31.31,0,0,0-.219-.515h-.034l-.579-.6c-.643.038-1.312.046-1.962.02,0-.9,0-1.81-.007-2.683C25.775,17.752,25.671,17.748,30.1,8.991ZM13.654,12.125a5.2,5.2,0,0,0-3.227,3.1L8.249,19.755c1.093-3.226,2.086-6.419,3.191-9.488,4.931-1.138,10.15-2.244,15.142-3.21l-.519,2.1s0,0,0,.006C21.475,10.14,17.31,11.133,13.654,12.125Zm-2.539-2.41a.3.3,0,0,0-.231.291c-1.147,3.183-2.173,6.5-3.339,9.921l.061-.366c.608-3.669,1.184-7.14,1.955-10.857,5.341-.956,10.209-1.937,15.6-2.931a6.912,6.912,0,0,1-.184.975C20.37,7.657,15.618,8.674,11.115,9.716ZM7.26,4.624c.9-.594,3.011-.506,4.672-.745.412-.057,1.041-.132,1.165.292a14.408,14.408,0,0,0,.767,1.841.365.365,0,0,0,.425.17c1.769-.353,8.444-1.972,9.782-2a6.24,6.24,0,0,1,.249,1.128c-5.181.963-9.847,1.9-14.926,2.807a.3.3,0,0,0-.382.227c-.8,3.82-1.385,7.366-2.008,11.12l0,.024c-.383-8.122.121-13.112.061-14.023C7.038,5.09,7,4.8,7.26,4.624Zm.2,18.172,3.526-7.33a4.691,4.691,0,0,1,2.826-2.752c4.471-1.213,9.7-2.43,15.546-3.619-4.156,8.224-3.953,7.886-4.292,8.362,0-2.008,0-3.958.046-5.078a.3.3,0,0,0-.295-.314l-.259-.432c-1.032,0-2.068.027-3.1.025l-.3.457a.292.292,0,0,0-.227.308c.026.421.008,5.411,0,6.84C16.32,20.489,11.99,21.589,7.462,22.8Zm15.664,3.826c-1.458-1.34-2.7-2.906-4.092-4.379.588-.025,1.431-.08,2.016-.07.206-.009.4.057.519-.152a.312.312,0,0,0-.027-.337c0-1.99.026-7.6.008-8.978l2.946-.03c-.061,2.085-.026,6.371-.026,9.044a.305.305,0,0,0,.256.47c.784,0,1.46.018,2.277.042C25.785,23.637,23.939,25.723,23.126,26.621Z"
                        fill="currentColor"
                      />
                      <path
                        d="M46.022,63.021a.3.3,0,0,0-.427.059l-1.006,1.328a.3.3,0,1,0,.486.368l1.006-1.329A.3.3,0,0,0,46.022,63.021Z"
                        transform="translate(-28.482 -38.622)"
                        fill="currentColor"
                      />
                      <path
                        d="M50.187,66.22a.3.3,0,0,0,.218-.372l-.318-1.221a.3.3,0,0,0-.59.154L49.816,66A.3.3,0,0,0,50.187,66.22Z"
                        transform="translate(-31.426 -39.476)"
                        fill="currentColor"
                      />
                      <path
                        d="M53.5,63.637a.305.305,0,0,0-.079-.424l-.85-.583a.3.3,0,1,0-.345.5l.849.583A.305.305,0,0,0,53.5,63.637Z"
                        transform="translate(-32.974 -38.394)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                </svg>
                DELETE
              </div>
            </div>
            <div
              className={`float-lead-btn float-button-won ${status === "won" ? "drag-over-won" : ""}`}
              onDragOver={(e) => {
                setStatus("won");
                e.preventDefault();
              }}
              onDragLeave={() => setStatus()}
              onDrop={(e) => {
                setConfirm(true);
                e.preventDefault();
              }}
            >
              <div className="d-flex align-items-center gap-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28.837"
                  height="27"
                  viewBox="0 0 28.837 27"
                >
                  <g
                    id="Group_211"
                    data-name="Group 211"
                    transform="translate(-5006.24 -1089.324)"
                  >
                    <path
                      id="collaborative_16843822"
                      d="M50.608,71.154a2.135,2.135,0,0,1,1.009-1.947,3.124,3.124,0,0,1,.5-.226c.07-.018.142-.1.215-.068.194.016.416-.117.589.041-.037.035-.081.032-.125.05.045.013.005.038,0,.067.014.023.038.011.054.027a2.146,2.146,0,0,0-1.433,2.033,1.462,1.462,0,0,0,1.736,1.293,1.482,1.482,0,0,0,1.111-1.743,2.3,2.3,0,0,0-.863-1.213,3.337,3.337,0,0,1-.332-.245.5.5,0,0,0-.147-.179A.149.149,0,0,0,53,68.995c.029-.017.071,0,.1-.032a2.832,2.832,0,0,1,.358-.053,2.241,2.241,0,0,1,.977,3.951,2.325,2.325,0,0,1-3.83-1.706ZM63.83,70.8a1.89,1.89,0,0,1,.519-1.054,2.06,2.06,0,0,1,.5-.288c.046-.081.151-.07.209-.131.018-.037.056-.021.079-.041s.043-.041.07-.057c-.315-.41-.936-.258-1.35-.07a2.124,2.124,0,0,0-.983,1.388A2.323,2.323,0,0,0,67.4,71.587a2.135,2.135,0,0,0-.794-2.219,1.819,1.819,0,0,0-1.118-.248c-.061,0-.3.022-.166.1-.008.027-.047.049-.009.067-.038.014-.077.006-.108.038.1.129.265.1.4.157a.035.035,0,0,1,.027.026c.027.052.1.032.152.055a1.023,1.023,0,0,1,.316.221,1.5,1.5,0,0,1,.1,2.231A1.407,1.407,0,0,1,63.83,70.8Zm9.577,2.291c-.237-1.3-1.561-1.462-2.526-.819-1.3.566-3.139,2.036-4.489,2.016-1.4-.291-2.744-.873-4.143-1.193a1.483,1.483,0,0,1-.731-.39,2.4,2.4,0,0,1-.611-1.45c-.109-.634-.22-1.306-.333-1.935-.127-.684-.158-1.851-1.062-1.864.063.029.172.055.209.1-.081.013-.2-.031-.047.053a.722.722,0,0,0-.469-.03c.824.114.89.722.931,1.415.01.753.2,1.5.228,2.26A2.612,2.612,0,0,0,61.647,73.6c1.04.414,2.143.668,3.2,1.053a4.248,4.248,0,0,0,2.266.36,23.633,23.633,0,0,0,3.74-1.791,4.258,4.258,0,0,1,1.066-.469.56.56,0,0,1,.587.8.355.355,0,0,1-.158.15A24.148,24.148,0,0,1,69.7,75.1c-1.186.521-2.583,1.122-2.964,2.5a24.8,24.8,0,0,0-.368,6.142c-1.43,0-2.916.018-4.342.014-.008-1.309,0-3.481,0-4.757A4.527,4.527,0,0,0,61.3,76.06,22.433,22.433,0,0,1,59.273,73.2,5.821,5.821,0,0,1,59,71.787c-.117-.882-.266-1.75-.362-2.633-.194-.667-.269-1.417.553-1.662-1.352,0-1.1,1.223-1.051,2.173.036.8.121,1.612.15,2.406a4.539,4.539,0,0,0,.494,2.039,9.166,9.166,0,0,0-2.475,3.3,4.394,4.394,0,0,0-.153,1.119c-.045,1.734-.045,3.469-.062,5.2-1.358-.012-2.975-.017-4.325-.007-.072-2.016.332-5.686-1.079-7.224-1.012-.963-2.419-1.321-3.617-1.987-.2-.1-.479-.255-.675-.369-.36-.25-1.01-.373-.881-.943.206-.936,1.2-.34,1.727-.048,1.011.511,2.145,1.174,3.19,1.613a3.577,3.577,0,0,0,2.867-.193c.771-.251,1.536-.517,2.316-.741a2.275,2.275,0,0,0,1.945-1.68,33.011,33.011,0,0,0,.273-3.337c-.032-.776.222-1.346,1.037-1.468-.061-.023-.17,0-.23-.016.065-.056.2-.071.011-.069a1.1,1.1,0,0,1,.23-.024c.07.039.04.093.1.126.036.011.018.029.037.043a.1.1,0,0,1,.053.037c.871-.334.562-1.976.551-2.734-.062-.606-.044-1.224-.112-1.832,2.312.037,4.735.056,7.051.013.467-.011.939-.025,1.407-.029a.463.463,0,0,0,.267-.827c-.79-.582-1.621-1.206-2.417-1.775.659-.506,1.737-1.307,2.387-1.812a.393.393,0,0,0-.247-.7c-.364.007-.9.011-1.262.023-2.074.034-4.189.045-6.251.285-.153.034-1.437.076-.938.137l-.011.022c-.054.016.023.022.046.027a1.373,1.373,0,0,0-.251.029c2.34.217,4.935.257,7.3.3-2.429,1.846-2.827,1.383-.139,3.324-2.244.042-4.649-.028-6.888.055a37.171,37.171,0,0,0-.336-3.747.266.266,0,0,1-.061.144c-.016.051-.033.1-.064.114a1.635,1.635,0,0,0-.06.238,25.121,25.121,0,0,0-.334,3.186c0,.069-.012.436-.015.514a3.393,3.393,0,0,1,.024.937,23.732,23.732,0,0,0-.04,2.805,1.664,1.664,0,0,0,.116.647c.019.1.057.28.066.362a1.225,1.225,0,0,0-1.312.922c-.056.16-.048.37-.106.524-.234,1.013-.163,3.39-.919,4.048a1.9,1.9,0,0,1-.592.328c-.995.258-1.987.575-2.961.892-1.783.83-2.883-.2-4.428-.994-1.106-.588-2.822-1.863-3.727-.321-.811,1.592.775,2.2,1.913,2.838a21.586,21.586,0,0,1,3.216,1.707,2.489,2.489,0,0,1,.63,1.385,28.07,28.07,0,0,1,.208,4.155c0,.531-.01,1.064-.017,1.6,0,.418.432.535.777.487,1.21-.035,3.776.018,4.953,0a.5.5,0,0,0,.579-.484c.009-1.279-.025-2.559-.042-3.838a11.548,11.548,0,0,1,.038-2.971c.344-1.179,1.3-2.037,1.823-3.136,2.567,3.593,2.132,2.675,2.13,7.057-.009.7,0,2.18,0,2.888a.511.511,0,0,0,.513.513c1.6-.007,3.321-.01,4.913-.024.384.013.909.024.908-.5-.017-.626-.035-1.251-.041-1.875,0-1.05-.01-2.1.08-3.144.164-2.069.815-2.422,2.589-3.245.813-.382,1.619-.794,2.392-1.253.671-.34,1.171-.809,1.025-1.624Z"
                      transform="translate(4961.645 1031.57)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_815"
                      data-name="Path 815"
                      d="M110.745,14.758a.186.186,0,0,1-.173-.119l-.265-.689a.093.093,0,0,0-.053-.053l-.689-.265a.186.186,0,0,1,0-.347l.689-.265a.093.093,0,0,0,.053-.053l.263-.684a.191.191,0,0,1,.153-.123.186.186,0,0,1,.2.118l.265.689a.093.093,0,0,0,.053.053l.689.265a.186.186,0,0,1,0,.347l-.689.265a.093.093,0,0,0-.053.053l-.265.689A.186.186,0,0,1,110.745,14.758Z"
                      transform="translate(4921.482 1079.54)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_816"
                      data-name="Path 816"
                      d="M110.11,13.487a.1.1,0,0,1-.089-.061l-.136-.352a.048.048,0,0,0-.027-.027l-.352-.136a.095.095,0,0,1,0-.177l.352-.136a.048.048,0,0,0,.027-.027l.135-.35a.1.1,0,0,1,.078-.063.1.1,0,0,1,.1.06l.136.352a.047.047,0,0,0,.027.027l.352.136a.095.095,0,0,1,0,.177l-.352.136a.047.047,0,0,0-.027.027l-.136.352A.1.1,0,0,1,110.11,13.487Z"
                      transform="translate(4920.758 1083.126)"
                      fill="currentColor"
                    />
                  </g>
                </svg>
                WON
              </div>
            </div>
            <MarkAsLostModal
              draggableLead={draggableLead}
              updateLead={(val) => {
                updateLead(val);
                setDragged(false);
              }}
              status={status}
              setStatus={(val) => setStatus(val)}
              handleCancel={() => setDragged(false)}
            />
          </Col>
        )}
      </Row>
      <Modal
        open={isConfirm}
        centered
        width={400}
        footer={null}
        onCancel={handleCancel}
      >
        <b>
          {status === "won"
            ? "Are you sure you want to mark this lead as won?"
            : "Are you sure you want to delete this lead?"}
        </b>
        <div
          className="mt40 d-flex justify-content-end align-items-center"
          style={{ gap: 20 }}
        >
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            type="primary"
            className={status === "won" ? "theme-btn" : "stop-sync"}
            onClick={() => {
              updateLead({
                ...draggableLead,
                status: status === "won" ? 16 : 19,
              });
              handleCancel();
            }}
          >
            {status === "won" ? "Mark as won" : "Delete"}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default KanbanView;
